import { render } from "./VSection.vue?vue&type=template&id=f7b47ea8"
import script from "./VSection.vue?vue&type=script&lang=js"
export * from "./VSection.vue?vue&type=script&lang=js"

import "./VSection.vue?vue&type=style&index=0&id=f7b47ea8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__